import React from 'react';
import { ExternalLink, Play, Server, Crosshair, Award } from 'lucide-react';

const games = [
  { 
    id: 'g1', 
    tag: 'AKTİF', 
    title: 'Türk Ordusu Simulasyonu V2', 
    desc: 'Roleplay topluluğumuzun ana amacı olan oyun. Güzel ve simulasyon tarzında.', 
    image: '/images/img2.jpg', 
    actions: [{ label: 'Şimdi Oyna', href: 'https://www.roblox.com/games/75451203633267/T-rk-Ordusu-Oyunu' }] 
  },
  { 
    id: 'g2', 
    tag: 'KLASİK', 
    title: 'TO - V1 Kampımızın İlk Adımı', 
    desc: 'Kampımızın ilk hayallerle yapılmış Aladağ mapi.', 
    image: '/images/img3.png', 
    actions: [] 
  },
  { 
    id: 'g3', 
    tag: 'SİSTEM', 
    title: 'TO - Eğitim Sistemi', 
    desc: 'V2.5 zamanlarında eklenmiş olan Yepyeni ve bize ait otomatik eğitim sistemi.', 
    image: '/images/img4.jpg', 
    actions: [] 
  },
  { 
    id: 'g4', 
    tag: 'MİRAS', 
    title: 'Eşref Bitlis Kışlası', 
    desc: 'Bir zamanlar kampımızın en iyi dönemlerinden roleplay amacıyla oluşturulmuş kışla.', 
    image: '/images/esref_bitlis.png', 
    actions: [] 
  },
];

export default function Games() {
  return (
    <section id="games" className="py-24 relative overflow-hidden bg-transparent">
      <div className="absolute inset-0 pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative z-10">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-orange-500/20 bg-orange-500/10 text-orange-400 text-xs font-bold uppercase tracking-widest mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse" />
            Portfolyo
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4">Projelerimiz</h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            Aktif oyunlarımız, gelişmiş askeri sistemlerimiz ve şanlı geçmişimizden unutulmaz projeler.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
          {games.map((g, i) => (
            <div key={g.id} className="group relative bg-slate-900/40 border border-slate-800 rounded-[2rem] overflow-hidden hover:-translate-y-2 transition-all duration-500 shadow-xl hover:shadow-2xl hover:shadow-blue-900/20">
              <div className="relative aspect-[16/9] overflow-hidden">
                <div className="absolute inset-0 bg-slate-800 animate-pulse" />
                <img src={g.image} alt={g.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 z-10" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/40 to-transparent z-20" />
                
                <div className="absolute top-5 left-5 z-30">
                  <span className="px-3 py-1.5 rounded-xl bg-black/60 backdrop-blur-md border border-white/10 text-xs font-bold text-white tracking-widest">
                    {g.tag}
                  </span>
                </div>
              </div>
              
              <div className="relative p-8 -mt-10 z-30">
                <div className="bg-slate-800/80 backdrop-blur-xl border border-slate-700 rounded-2xl p-6 shadow-xl">
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-blue-400 transition-colors">{g.title}</h3>
                  <p className="text-slate-400 leading-relaxed mb-6">
                    {g.desc}
                  </p>
                  
                  {g.actions.length > 0 && (
                    <div className="flex flex-wrap gap-3">
                      {g.actions.map(a => (
                        <a key={a.label} href={a.href} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-semibold transition-all shadow-lg shadow-blue-900/50 hover:shadow-blue-500/50">
                          {a.label === 'Şimdi Oyna' ? <Play size={16} fill="currentColor" /> : <ExternalLink size={16} />}
                          <span>{a.label}</span>
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
